import React from "react";
import { motion } from "framer-motion";

const STEPS = [
  { n: "01", title: "Request a quote", text: "Tell us about your vehicle and the result you want. Takes under 90 seconds." },
  { n: "02", title: "Lock in a slot", text: "We confirm price, time, and exact arrival window — usually same week." },
  { n: "03", title: "We arrive on-site", text: "Fully mobile detailing at your address. We work while you live your life." },
  { n: "04", title: "Inspection & handoff", text: "Walk-around with photos. We don't leave until you're thrilled." },
];

export default function HowItWorks() {
  return (
    <section id="how" data-testid="how-section" className="section bg-[#0a0a0a] border-y border-white/5">
      <div className="container-pd">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-5">
            <div className="divider-gold" />
            <span className="eyebrow">06 · How It Works</span>
          </div>
          <h2 className="font-display font-black text-white text-3xl sm:text-4xl lg:text-5xl tracking-tighter leading-[1.05]">
            Four steps. Zero hassle.
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/5">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: i * 0.07 }}
              className="bg-[#0a0a0a] p-8 group hover:bg-[#0c0c0c] transition-colors"
              data-testid={`how-step-${i}`}
            >
              <div className="font-display text-5xl font-black text-[#D4AF37]/20 group-hover:text-[#D4AF37]/60 transition-colors">{s.n}</div>
              <h3 className="mt-5 font-display font-bold text-xl text-white">{s.title}</h3>
              <p className="mt-3 text-sm text-zinc-400 leading-relaxed">{s.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
